var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',{scopedSlots:_vm._u([{key:"topLink",fn:function(){return [(!_vm.isIosApp)?_c('v-btn',{staticClass:"text-none",attrs:{"text":"","color":"txtSecondary","to":{name: 'register'}}},[_vm._v(" "+_vm._s(_vm.$t('entrance.create_user'))+" ")]):_vm._e()]},proxy:true}])},[_c('login',{on:{"success":_vm.onLoginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }